import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { shippingFulfillmentOptions, shippingFulfillmentValues } from './constants'

const ShippingFulfillmentSelector = ({ value, onChange }) => {
  const { t } = useTranslation()

  return (
    <ComboBox
      label={t('Estado de envío')}
      menuItems={shippingFulfillmentOptions.map(option => ({ ...option, label: t(option.label) }))}
      value={value ? shippingFulfillmentValues.update : shippingFulfillmentValues.noUpdate}
      handleChange={e => onChange('shipping_fulfillment', e.target.value === shippingFulfillmentValues.update)}
    />
  )
}

export default ShippingFulfillmentSelector
